export const appCloudfrontPath = `${import.meta.env.VITE_CLOUDFRONT_DOMAIN}`;
export const appBasePath = `${import.meta.env.VITE_BASE_PATH}`;
